import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const exportAsPDF = () => {
    const boxElement = document.getElementById("export-box");

    html2canvas(boxElement, {
        scale: 2, // Increase scale for better quality
        useCORS: true, // Handle cross-origin images
        allowTaint: true,
    }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png", 1.0); // Use PNG for better clarity
        const pdf = new jsPDF("p", "mm", "a4"); // Use A4 page size

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        let imgWidth = pageWidth - 20; // Keep some margin
        let imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

        // If image height is larger than page height, scale it down
        if (imgHeight > pageHeight - 20) {
            imgHeight = pageHeight - 20;
            imgWidth = (canvas.width * imgHeight) / canvas.height;
        }

        const x = (pageWidth - imgWidth) / 2; // Center horizontally
        const y = (pageHeight - imgHeight) / 2; // Center vertically

        pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
        pdf.save("exported-pdf.pdf");
    });
};

export default exportAsPDF;
